import React from 'react';
import './HomeContactStrip.css';

const HomeContactStrip = ({ onNavigate }) => {
  return (
    <section className="home-contact-strip">
      <div className="home-contact-strip-inner">
        <div className="home-contact-strip-content">
          <span className="home-contact-strip-label">Bize ulaşın</span>
          <h2 className="home-contact-strip-title">İletişime Geçin</h2>
          <p className="home-contact-strip-desc">
            Üyelik, mesleki standartlar, sanayi iş birlikleri veya genel sorularınız için bize yazabilirsiniz. 
            E-posta ve iletişim sayfamızdan bize ulaşabilirsiniz.
          </p>
          <div className="home-contact-strip-links">
            <a href="mailto:info@tkmb.org" className="home-contact-strip-link home-contact-strip-email">
              info@tkmb.org
            </a>
            <a href="https://www.tkmb.org" target="_blank" rel="noopener noreferrer" className="home-contact-strip-link home-contact-strip-web">
              www.tkmb.org
            </a>
          </div>
        </div>
        <div className="home-contact-strip-action">
          <button
            type="button"
            className="home-contact-strip-btn"
            onClick={() => onNavigate && onNavigate('contact')}
          >
            İletişim Sayfası
          </button>
        </div>
      </div>
    </section>
  );
};

export default HomeContactStrip;
